<template>
  <div>
    <h1 class="center">INSTITUTO</h1>
    <h3 class="center">Personalización</h3>
    <v-container style="">
      <div>
        <v-row>
          <v-col cols="12" lg="7" class="mr-5">
            <div style="width: 100%;">
              <table>
                <tr>
                  <td>MISION</td>
                  <td><textarea placeholder="ESCRIBIR" v-model="datosInstituto.mision" class="textarea-estilo-input"
                      rows="2"></textarea></td>
                </tr>
                <tr>
                  <td>VISION</td>
                  <td><textarea placeholder="ESCRIBIR" v-model="datosInstituto.vision" class="textarea-estilo-input"
                      rows="2"></textarea></td>

                </tr>
                <tr>
                  <td>HISTORIA</td>
                  <td><textarea placeholder="ESCRIBIR" v-model="datosInstituto.historia" class="textarea-estilo-input"
                      rows="2"></textarea></td>
                </tr>
                <tr>
                  <td>ACCESIBILIDAD</td>
                  <td><textarea placeholder="ESCRIBIR" v-model="datosInstituto.accesibilidad"
                      class="textarea-estilo-input" rows="2"></textarea></td>
                </tr>
                <tr>
                  <td>PRINCIPIOS <br> VALORES</td>
                  <td>
                    <div style="display: flex; gap: 16px;" class="mr-5">
                      <div style="flex: 1;">
                        <label>PRINCIPIOS</label>
                        <textarea placeholder="ESCRIBIR" v-model="datosInstituto.principios"
                          class="textarea-estilo-input" rows="2"></textarea>
                      </div>
                      <div style="flex: 1;">
                        <label>VALORES</label>
                        <textarea placeholder="ESCRIBIR" v-model="datosInstituto.valores" class="textarea-estilo-input"
                          rows="2"></textarea>
                      </div>
                    </div>
                    <span>Separado por comas</span>
                  </td>
                </tr>
                <tr>
                  <td>DIRECCIÓN (OPCIONAL)</td>
                  <td><input type="text" placeholder="ESCRIBIR" v-model="datosInstituto.direccion" /></td>

                </tr>
                <tr>
                  <td>TELEFONO <br> CORREO</td>
                  <td>
                    <div style="display: flex; gap: 16px;" class="mr-5">
                      <div style="flex: 1;">
                        <label>TELEFONO/CELULAR</label>
                        <input type="text" placeholder="ESCRIBIR" v-model="datosInstituto.telefono" />
                      </div>
                      <div style="flex: 1;">
                        <label>CORREO</label>
                        <input type="text" placeholder="ESCRIBIR" v-model="datosInstituto.correo" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>HORARIO DE ATENCION <br> DIAS <br>HORAS</td>
                  <td>
                    <div style="display: flex; gap: 16px;" class="mr-5">
                      <div style="flex: 1;">
                        <label>DIAS</label>
                        <input type="text" placeholder="ESCRIBIR" v-model="datosInstituto.horario_dias" />
                      </div>
                      <div style="flex: 1;">
                        <label>HORAS</label>
                        <input type="text" placeholder="ESCRIBIR" v-model="datosInstituto.horario_horas" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><v-btn color="#0000ff" dark class="center" @click="llenarDatosRecomendados()">
                      <h2>RECOMENDADO</h2>
                    </v-btn></td>
                  <td colspan="2"><v-btn color="#0000ff" dark class="center" @click="actualizarInstituto()">
                      <h2>GUARDAR TODO</h2>
                    </v-btn></td>
                </tr>
              </table>
            </div>
          </v-col>
          <v-col v-if="false">
            <h3>VISTA PREVIA</h3>
            <div class="line" style="border-radius: 5px; width: 100%; overflow: hidden" :style="{
              background: `linear-gradient(to bottom, ${datosAjustes.colorSuperior} 10%, ${datosAjustes.colorInferior} ${datosAjustes.colorDegradado * 25}%, ${datosAjustes.colorInferior} 100%)`
            }">
              <div :style="{ backgroundColor: datosAjustes.colorCabecera }" style="height: 20px;">
                <h2 class="center" style="display: flex; color: aquamarine;">
                  <span class="ml-2" :style="{ color: datosAjustes.colorTextoLogo }">
                    <v-icon small :style="{ color: datosAjustes.colorTextoLogo }">mdi-menu</v-icon>
                    {{ datosAjustes.textoLogoCorto }}</span>
                  <v-spacer></v-spacer>
                  <span :style="{ color: datosAjustes.colorTexto1 }" class="mr-3"
                    style="text-align: right; font-size: xx-small;">
                    <v-icon :style="{ color: datosAjustes.colorTexto1 }" small>mdi-home</v-icon>
                    <span class="ml-1 mr-4">Oferta Academica</span> Matriculate</span>
                </h2>
              </div>
              <div style="background-color: #F2F2F280; height: 80px; width: 100%; align-content: center;">
                <h3 class="center">VIDEO</h3>
              </div>
              <h3 :style="{ color: datosAjustes.colorTexto2 }" class="pl-8 pr-8 pt-2 center" style="font-size: 5pt;"
                v-html="$textoFormateado($ajustes.textoMotivacion)"></h3>
              <v-row class="ma-0 mt-1">
                <v-col v-for="x in 4" class="pa-2" :key="'testdemo' & x" lg="3" cols="3">
                  <v-card :style="{ backgroundColor: datosAjustes.colorElemento }" style=" height: 80px;"></v-card>

                </v-col>
              </v-row>
              <br>
              <div :style="{ backgroundColor: datosAjustes.colorPie }">
                <h3 class="pt-2 center" :style="{ color: datosAjustes.colorTexto1 }">
                  <span class="ml-2">
                    {{ datosAjustes.textoPie }}</span>
                </h3>
                <div class="center">
                  <v-icon class="ml-1" dark small>mdi-facebook</v-icon>
                  <v-icon class="ml-1" dark small>mdi-instagram</v-icon>
                  <v-icon class="ml-1" dark small>mdi-email</v-icon>
                </div>
                <br>
              </div>
            </div>

          </v-col>
        </v-row>
      </div>
      <br>
    </v-container>
  </div>
</template>
<script>
import * as axios from "./axiosInstituto";
export default {
  components: {
  },
  data() {
    return {
      indicaciones: "Escriba entre: * * negrita; ~ ~ cursiva; _ _ subrayado; y \n para añadir un salto de linea",
      datosInstituto: {
        mision: "",
        vision: "",
        historia: "",
        accesibilidad: "",
        principios: "",
        valores: "",
        direccion: "",
        telefono: "",
        correo: "",
        horario_dias: "",
        horario_horas: "",
      },
      showMenu: true,
      show: {
        responsible: "",
      },

    };
  },
  mounted() {
    this.obtenerInstituto()
  },
  created() {
  },
  methods: {
    async obtenerInstituto() {
      var response = await axios.obtenerInstituto()
      var instituto = response.data
      try {
        this.llenarDatos(instituto)
      } catch (error) { null }
    },
    async actualizarInstituto() {
      var response = await axios.actualizarInstituto(this.datosInstituto)
      if (response) {
        alert("GUARDADO CON EXITO")
      }
    },
    llenarDatos(aux) {
      this.datosInstituto.mision = aux.mision;
      this.datosInstituto.vision = aux.vision;
      this.datosInstituto.historia = aux.historia;
      this.datosInstituto.accesibilidad = aux.accesibilidad;
      this.datosInstituto.principios = aux.principios;
      this.datosInstituto.valores = aux.valores;
      this.datosInstituto.direccion = aux.direccion;
      this.datosInstituto.telefono = aux.telefono;
      this.datosInstituto.correo = aux.correo;
      this.datosInstituto.horario_dias = aux.horario_dias;
      this.datosInstituto.horario_horas = aux.horario_horas;
    },
    llenarDatosRecomendados() {
      this.datosInstituto.mision = "Nuestra misión es brindar una educación integral, inclusiva y de calidad, fomentando valores éticos, pensamiento crítico y compromiso social.";
      this.datosInstituto.vision = "Ser una institución educativa reconocida por su excelencia académica, innovación pedagógica y formación de ciudadanos responsables y solidarios.";
      this.datosInstituto.historia = "Fundada con el propósito de contribuir al desarrollo educativo de la comunidad, nuestra institución ha crecido con el compromiso de formar generaciones con altos valores y conocimientos.";
      this.datosInstituto.accesibilidad = "Nuestras instalaciones están adaptadas para garantizar el acceso y la participación plena de personas con discapacidad, asegurando una experiencia educativa equitativa.";
      this.datosInstituto.principios = "Compromiso con la verdad, respeto por la diversidad, equidad, inclusión y responsabilidad social.";
      this.datosInstituto.valores = "Honestidad, respeto, responsabilidad, solidaridad, justicia, tolerancia y perseverancia.";
      this.datosInstituto.direccion = "Calle Principal #123, Quito, Ecuador";
      this.datosInstituto.telefono = "+59398765432";
      this.datosInstituto.correo = "instituto@instituto.com";
      this.datosInstituto.horario_dias = "Lunes a Viernes";
      this.datosInstituto.horario_horas = "08h00 a 17h00";
    }
  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  text-align: left;
  border: 1px solid #000;
  padding: 4px;
}

input[type="text"],
input[type="email"],
input[type="color"] {
  width: 95%;
  font-size: small;
  padding: 2px;
  box-sizing: border-box;
  border: #000 1px solid;
  border-radius: 3px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: blue;
  color: white;

}

.textarea-estilo-input {
  resize: none;
  width: 95%;
  font-size: small;
  padding: 2px;
  border: #000 1px solid;
  border-radius: 3px;
}

.textarea-estilo-input:focus {
  outline: none;
  border-color: #000000;
  box-shadow: 0 0 3px rgba(102, 175, 233, 0.6);
}
</style>